import { StripePaymentResponse } from 'model';
import { StripeSessionData } from '../api/UserLedgerAPI.js';

export interface PurchaseSubscriptionState {
	status?: 'starting' | 'started' | 'complete' | 'error';
	error?: Error | string;
	sessionId?: string;
	stripeOpen?: boolean;
	stripeSession?: StripeSessionData;
}

export type PurchaseSubscriptionAction =
	| { type: 'StartPurchase' }
	| { type: 'SessionStarted'; data: StripePaymentResponse }
	| { type: 'SessionLoaded'; data: StripeSessionData }
	| { type: 'CompletePurchase' }
	| { type: 'StripeLaunched' }
	| { type: 'StripeClosed'; canceled?: boolean }
	| { type: 'PurchaseError'; error: Error | string };

export function purchaseSubscriptionReducer(
	state: PurchaseSubscriptionState,
	action: PurchaseSubscriptionAction
): PurchaseSubscriptionState {
	switch (action.type) {
		case 'StartPurchase':
			return {
				status: 'starting'
			};
		case 'SessionStarted':
			return {
				...state,
				status: 'started',
				sessionId: action.data.stripeSession
			};
		case 'SessionLoaded':
			return {
				...state,
				stripeSession: action.data
			};
		case 'CompletePurchase': {
			return {
				status: 'complete'
			};
		}
		case 'PurchaseError':
			return {
				...state,
				status: 'error',
				error: action.error
			};
		case 'StripeLaunched': {
			return {
				...state,
				stripeOpen: true
			};
		}
		case 'StripeClosed': {
			if (action.canceled) {
				// the transaction was canceled by closing the stripe window early
				return {};
			}
			return {
				...state,
				stripeOpen: false
			};
		}
		default:
			return state;
	}
}
